export default __webpack_public_path__ + "static/media/Giuseppe Cederna.95843b2a.jpg";